export const header = {
  height: 48,
} as const
